module.exports = __webpack_public_path__ + "img/02.54b133d1.png";